class RequestError extends Error {}

export default RequestError;
